import { Alert, Space } from "antd";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { sports } from "~config/sports";
import { useGetSeasonLeadersStatisticReportUrl } from "~pages/Reports/hooks/useGetSeasonLeadersStatisticReportUrl.ts";
import { useGetSeasonPersonsStatisticReportUrl } from "~pages/Reports/hooks/useGetSeasonPersonsStatisticReportUrl.ts";
import { ReportButton } from "./components/ReportButton";
import { useGetSeasonAppointmentsReportUrl } from "./hooks/useGetSeasonAppointmentsReportUrl";
import { useGetSeasonCardsReportUrl } from "./hooks/useGetSeasonCardsReportUrl";
import { useGetSeasonEntitiesReportUrl } from "./hooks/useGetSeasonEntitiesReportUrl";
import { useGetSeasonEntitiesStatisticReportUrl } from "./hooks/useGetSeasonEntitiesStatisticReportUrl";

const SeasonReportsPage = () => {
  const { sport, organizationId, seasonId } = useParams();
  const { formatMessage } = useIntl();

  return useMemo(() => {
    switch (sport) {
      case sports.BASKETBALL:
        return (
          <Space>
            <ReportButton
              title={formatMessage({ id: "reports.seasonEntitiesStatistic" })}
              fileName={formatMessage({
                id: "reports.seasonEntitiesStatistic.fileName",
              })}
              queryKey={["seasonEntitiesStatisticReport", sport, organizationId, seasonId]}
              getHook={useGetSeasonEntitiesStatisticReportUrl}
            />
            <ReportButton
              title={formatMessage({ id: "reports.seasonPersonsStatistic" })}
              fileName={formatMessage({
                id: "reports.seasonPersonsStatistic.fileName",
              })}
              queryKey={["seasonPersonsStatisticReport", sport, organizationId, seasonId]}
              getHook={useGetSeasonPersonsStatisticReportUrl}
            />
            <ReportButton
              title={formatMessage({ id: "reports.seasonLeadersStatistic" })}
              fileName={formatMessage({
                id: "reports.seasonLeadersStatistic.fileName",
              })}
              queryKey={["seasonLeadersStatisticReport", sport, organizationId, seasonId]}
              getHook={useGetSeasonLeadersStatisticReportUrl}
            />
          </Space>
        );
      case sports.HOCKEY:
      case sports.HANDBALL:
        return (
          <Space>
            <ReportButton
              title={formatMessage({ id: "reports.seasonEntities" })}
              fileName={formatMessage({
                id: "reports.seasonEntities.fileName",
              })}
              queryKey={["seasonEntitiesReport", sport, organizationId, seasonId]}
              getHook={useGetSeasonEntitiesReportUrl}
            />
            <ReportButton
              title={formatMessage({ id: "reports.seasonCards" })}
              fileName={formatMessage({ id: "reports.seasonCards.fileName" })}
              queryKey={["seasonCardsReport", sport, organizationId, seasonId]}
              getHook={useGetSeasonCardsReportUrl}
            />
            <ReportButton
              title={formatMessage({ id: "reports.seasonAppointments" })}
              fileName={formatMessage({
                id: "reports.seasonAppointments.fileName",
              })}
              queryKey={["seasonAppointmentsReport", sport, organizationId, seasonId]}
              getHook={useGetSeasonAppointmentsReportUrl}
            />
          </Space>
        );
      default:
        return <Alert style={{ width: "max-content" }} message={formatMessage({ id: "reports.notSupported" })} type="warning" showIcon />;
    }
  }, [sport, organizationId, seasonId, formatMessage]);
};

export default SeasonReportsPage;
